import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const PATH_TEMPLATE = '/workflow-reports/creators/{creatorId}/paralegal-report';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const getParalegalReport = async ({ creatorId, startDate, endDate }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/workflow-reports/creators/${creatorId}/paralegal-report`, {
    params: {
      endDate,
      startDate,
    },
  });
  return response.data;
};

export default getParalegalReport;
